// extracted by mini-css-extract-plugin
export default {"root":"DesktopIcon_root__oukOG","iconWrapper":"DesktopIcon_iconWrapper__ZuanD","label":"DesktopIcon_label__ZVRDU"};